import React from "react";
import { observer } from "mobx-react";

const ProctorTypes = observer((props) => {
    return (
        <>
            {props?.proctorTypes ? (
                <ul>
                {props?.proctorTypes.map((type, index) => (
                  <>
                  {props.SessionStore?.proctorSubTypes[type] ? (
                    <li key={index}>
                     {props.SessionStore?.proctorSubTypes[type]?.title}
                    </li>
                  ): (<></>)}
                 </>
                ))}
              </ul>
            ) : (<></>)}
        </>
    );
});

export default ProctorTypes;